import React, { useCallback, useState } from 'react';
import axios from 'axios';
import { Form } from 'informed';
import { get } from 'lodash';
import { toast } from 'react-toastify';
import { InputTypeText } from '../elements';
import { API_URL } from '../../lib/const';
import { Link, useHistory } from 'react-router-dom';
import FlexVertical from '../components/FlexVertical';
import ButtonAuth from '../components/ButtonAuth';
import useQueryString from '../../hooks/useQueryString';

const Login = () => {
  const [logginIn, setLogginIn] = useState(false);
  const history = useHistory();
  const queryString = useQueryString();

  const signIn = async (username, password) => {
    const response = await axios.post(`${API_URL}/login`, {
      username,
      password,
    });

    return response.data;
  };

  const subscribeOnOnboardingProcess = async (userId, onboardingId) => {
    const response = await axios.post(`${API_URL}/onboarding/enrollments`, {
      onboarding: onboardingId,
      user: userId,
    });

    return response.data;
  };

  const handleSubmit = useCallback(
    async (values) => {
      setLogginIn(true);

      try {
        const { token, user, ...data } = await signIn(
          values.username,
          values.password
        );

        localStorage.setItem('token', token);
        localStorage.setItem('userId', user.id);

        setLogginIn(false);

        const dashboardGroups = [
          'convidante',
          'hospital',
          'acadêmico',
          'financeiro',
          'saúde',
          'suporte',
        ];
        const hasDashboardGroup = user.groups.some((g) =>
          dashboardGroups.includes(g.toLowerCase())
        );

        if (hasDashboardGroup || user.is_superuser) {
          history.push('/dashboard', { ...data });
        } else {
          if (queryString.get('processo')) {
            try {
              const { token } = await subscribeOnOnboardingProcess(
                user.id,
                queryString.get('processo')
              );

              history.push(`/inscrever/${token}`);
            } catch (err) {
              console.log(err);
              history.push('/processos', { ...data });
            }
          } else {
            history.push('/processos', { ...data });
          }
        }
      } catch (error) {
        setLogginIn(false);

        if (get(error, 'response.status') === 400) {
          toast.error('Login ou senha incorretos.', {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        } else {
          toast.error('Erro inesperado. Por favor, tente novamente.');
        }
      }
    },
    [queryString]
  );

  return (
    <div className="login-background">
      <Form className="login-card shadow" onSubmit={handleSubmit}>
        <figure className="text-center mt-2">
          <img
            src={require('../../assets/img/logo-green.svg')}
            className="login-logo"
            alt="notification"
          />
        </figure>

        <InputTypeText label="Login" type="text" field="username" required />
        <InputTypeText
          label="Senha"
          type="password"
          field="password"
          required
        />
        <FlexVertical height="150px">
          <ButtonAuth type="submit" disabled={logginIn}>
            {logginIn ? 'Entrando...' : 'ENTRAR'}
          </ButtonAuth>
          <Link
            style={{ fontWeight: 'bold', color: '#489D96' }}
            to={`/logon?${queryString.toString()}`}
          >
            Crie seu login para primeiro acesso
          </Link>
          <Link
            style={{ color: '#489D96' }}
            to={`/reset-password?${queryString.toString()}`}
          >
            Esqueceu sua senha?
          </Link>
        </FlexVertical>
      </Form>
    </div>
  );
};

export default Login;
